// @ts-ignore
export default function (dataset,chainName:string) {
    const params = [{
        chainId: dataset.nft_marketplace_core_taxonomy_blockchain_currency_chainid[0],
        rpcUrls: dataset.nft_marketplace_core_taxonomy_blockchain_currency_rpc_url,
        chainName: chainName,
        nativeCurrency: {
            name: dataset.nft_marketplace_core_taxonomy_blockchain_currency_symbol[0],
            symbol: dataset.nft_marketplace_core_taxonomy_blockchain_currency_symbol[0],
            decimals: 18
        },
    }];
    try {
        return window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{
                chainId: dataset.nft_marketplace_core_taxonomy_blockchain_currency_chainid[0],
            }]
        })
    } catch (switchError) {
        return window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: params
        });
    }
}